import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.LogPane.title',
    defaultMessage: 'Log Pane',
  },
})
